import React, {Component} from 'react';
import RubricaList from './RubricaList'
import OrganizzazioniList from "./OrganizzazioniList";
import DipartimentiList from "./DipartimentiList";

class RubricaListSwitcher extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0
        };
    }

    changeTab(tabnum){
        this.setState({activeTab: tabnum})
    }

    render() {
        let currView = null;
        if (this.state.activeTab === 0){
            currView = <RubricaList {...this.props} />
        }
        else if (this.state.activeTab === 1){
            currView = <OrganizzazioniList {...this.props} />
        }
        else if (this.state.activeTab === 2){
            currView = <DipartimentiList {...this.props} />
        }
        else
        {
            currView = null
        }

        return <div>
            <div className="ui top attached tabular menu">
                <a className={this.state.activeTab === 0 ? "item active": "item"} onClick={()=>(this.changeTab(0))} ><i className="ui user icon"/> Soggetti</a>
                <a className={this.state.activeTab === 2 ? "item active": "item"} onClick={()=>(this.changeTab(2))}><i className="ui building icon"/> Dipartimenti</a>
                <a className={this.state.activeTab === 1 ? "item active": "item"} onClick={()=>(this.changeTab(1))}><i className="ui industry icon"/> Organizzazioni</a>
            </div>
            <div className="ui bottom attached tab segment active">
                {currView}
            </div>
        </div>
    }
}



export default RubricaListSwitcher;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaListSwitcher.js
 **/